import classNames from "classnames";
import { observer } from "mobx-react-lite";

import { enableApiOriginSelector } from "@/shared/constants/environments";
import { useGeneralState, useUserState } from "@/shared/stores/app-state";

import { Logo } from "../logo";

import { BreadCrumbs } from "./breadcrumbs";
import { Clock } from "./clock";
import { HeaderMenu } from "./header-menu";
import { MobileSideMenu } from "./mobile-side-menu";
import { OriginSelect } from "./origin-select";
import { StatusConnection } from "./status-connection";
import s from "./header.module.scss";

export const Header = observer(() => {
	const { isMobile } = useGeneralState();
	const { isLoggedIn } = useUserState();

	const headerClassName = classNames(s.header, { [s.mobileHeader]: isMobile });

	if (!isLoggedIn && enableApiOriginSelector)
		return (
			<header className={headerClassName}>
				<OriginSelect />
			</header>
		);

	if (!isLoggedIn) return null;

	return (
		<header data-testid="header" className={headerClassName}>
			{isMobile && (
				<div className="flex items-center gap-4">
					<MobileSideMenu />

					<Logo />
				</div>
			)}

			<div data-testid="breadCrumbs" className={s.breadCrumbsWrapper}>
				{enableApiOriginSelector && <OriginSelect />}

				{!isMobile && <BreadCrumbs />}
			</div>

			<div className={s.userStatusWrapper}>
				<Clock />

				<StatusConnection />

				<HeaderMenu />
			</div>
		</header>
	);
});
